import { Breakpoints, compareBreakpoints } from '../helpers/breakpoint';
import { getDynamicTokens, getFluidTokens } from './dynamic-tokens';
import { createCSSVarName } from './create-css-var-name';
import { designTokens } from './example-design-tokens';
export function getMediaQueryVars(optionsOverride) {
    const tokens = optionsOverride
        ? optionsOverride.tokens
        : undefined;
    const dynamicTokens = getDynamicTokens(tokens || designTokens);
    const dynamicTokenCSS = Object.keys(dynamicTokens)
        .sort(compareBreakpoints)
        .reduce((result, breakpoint) => {
        const styles = Object.keys(dynamicTokens[breakpoint]).reduce((cssVars, path) => `
				${cssVars}
				${createCSSVarName(path)}: ${dynamicTokens[breakpoint][path]};
			`, '');
        return breakpoint === '0'
            ? `${styles}
					${result}`
            : `${result}
					@media (min-width: ${breakpoint}) {
						${styles}
					}`;
    }, '');
    const fluidTokens = getFluidTokens(tokens || designTokens);
    const fluidTokenCSS = fluidTokens.reduce((acc, { path, min, max }) => {
        const m = (parseInt(max, 10) - parseInt(min, 10)) /
            (Breakpoints.b1920 - Breakpoints.b560);
        const b = parseInt(min, 10) - m * Breakpoints.b560;
        const pref = `${m * 100}vw ${b < 0 ? '-' : '+'} ${Math.abs(b) / 16}rem`;
        return `${acc}
			${createCSSVarName(path)}: clamp(${parseInt(min, 10) / 16}rem, ${pref}, ${parseInt(max, 10) / 16}rem);
		`;
    }, '');
    return `
		${dynamicTokenCSS}
		${fluidTokenCSS}
	`;
}
